export const capitalFirstLetter = (str: string) => {
  return str?.charAt(0).toUpperCase() + str?.toLowerCase().slice(1);
};

export const getKeyValuePairs = (data: any) => {
  return data?.map((el: string) => {
    return {
      label: el,
      value: el,
    };
  });
};

const regEx = new RegExp("/[^0-9]*.?[^0-9]*$/");

export const allowOnlyNumbers = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event?.key?.length === 1 && regEx.test(event?.key)) {
    event.preventDefault();
  }
};

export const colourOptions = [
  {
    value: "Bachelors of Management Service",
    label: "Bachelors of Management Service",
    color: "#00B8D9",
    isFixed: true,
  },
  { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
  { value: "purple", label: "Purple", color: "#5243AA" },
  { value: "red", label: "Red", color: "#FF5630", isFixed: true },
  { value: "orange", label: "Orange", color: "#FF8B00" },
  { value: "yellow", label: "Yellow", color: "#FFC400" },
  { value: "green", label: "Green", color: "#36B37E" },
  { value: "forest", label: "Forest", color: "#00875A" },
  { value: "slate", label: "Slate", color: "#253858" },
  { value: "silver", label: "Silver", color: "#666666" },
];
